<ng-container [formGroup]="form">
   <mat-checkbox formControlName="value">{{ label }}</mat-checkbox>
</ng-container>
